<template>
    <div class="collection-list">
        <div class="collection-list__content">
            <div v-for="(collection, index) in limitCollections"
                 class="collection-list__item"
                 :key="index"
            >
                <slot :collection="collection" :index="index" >
                    <TotemCollectionItem :collection="collection"/>
                </slot>
            </div>
        </div>
        <TotemButton
            icon="add"
            size="medium"
            color="primary"
            class="collection-list__load-more"
            @click="loadMore"
            v-if="limit < collections.length"
            :label="$t('General.load_more')"
        />
        <TotemBackToTop />
    </div>
</template>

<script>
    import routeHelper from 'components/shared/mixins/routeHelper'
    import { mapGetters } from 'vuex'

    export default {
        props: {
            collections: Array,
            isMenuToggled: Boolean
        },
        mixins: [ routeHelper ],
        data () {
            return {
                hoverItem: '',
                limit: 20
            }
        },
        computed: {
            limitCollections () {
                return this.collections.filter((collection, index) => index < this.limit)
            },
            ...mapGetters({
                getCollectionsLimitByPackage: 'CoursesCollections/getCollectionsLimitByPackage'
            }),
            routePackage () {
                if (this.$route.params.packageSlug !== undefined) {
                    return this.$route.params.packageSlug
                } else {
                    return this.$route.name
                }
            }
        },
        methods: {
            loadMore () {
                this.limit += 20
                this.$store.dispatch('CoursesCollections/increaseCollectionsLimit', { id: this.routePackage, limit: this.limit })
            },
            limitByPackage () {
                if (this.getCollectionsLimitByPackage(this.routePackage) === undefined) {
                    this.limit = 20
                } else {
                    this.limit = this.getCollectionsLimitByPackage(this.routePackage).limit
                }
            }
        },
        watch: {
            limit: {
                handler: 'limitByPackage',
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .collection-list {
        display: flex;
        flex-direction: column;

        &__content {
            @include collection_list;
        }

        &__item {
            @include collection_list_item;
        }

        &__load-more {
            align-self: center;
            margin: 40px 30px 30px;
        }
    }
</style>
